import React from 'react';
import { User } from 'lucide-react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { useUserStore } from '../../stores/StoreProvider';

const UserMessage = ({ message }) => {
  const user = useUserStore();
  const avatar = user.profile?.avatar;
  const initials = user.profile?.first_name?.[0] + (user.profile?.last_name?.[0] || '');

  return (
    <div className="flex justify-end items-end mb-4">
      <div className="max-w-xs lg:max-w-md px-4 py-3 bg-blue-600 text-white rounded-2xl shadow-sm">
        <div className="flex items-start space-x-2">
          <div className="flex-1">
            <div className="text-sm leading-relaxed prose-user">
              <ReactMarkdown 
                remarkPlugins={[remarkGfm]}
              >
                {message.content[0].text.value}
              </ReactMarkdown>
            </div>
            <p className="text-xs text-blue-100 mt-1">
              {new Date(message.created_at).toLocaleTimeString()}
            </p>
          </div>
          <User className="w-5 h-5 text-blue-100 mt-0.5 flex-shrink-0" />
        </div>
      </div>
      {avatar ? (
        <img
          src={avatar}
          alt="User"
          className="w-9 h-9 rounded-full ml-2 object-cover"
        />
      ) : (
        <div className="w-9 h-9 rounded-full ml-2 bg-blue-600 flex items-center justify-center">
          <span className="text-white font-bold text-sm">{initials}</span>
        </div>
      )}
    </div>
  );
};

export default UserMessage; 